// TODO (tech debt): these setters mutate the offer view-model in place, which is a
// long-standing anti-pattern exposed by the Apollo upgrade (apollo-angular 4→7 / @apollo/client
// 3.7→3.11) now deep-freezing cache-read results. `setCustomPropertyValueImmutable` + the line
// clone in offer.service.ts `mapQuoteToOffer` are interim safeguards, not the real fix.
// Next steps (medium-term, sequence matters):
//   1. Establish an ownership boundary: `mapQuoteToOffer` constructs the view-model immutably
//      from readonly Apollo results; downstream only ever touches the owned model.
//   2. Enforce it with readonly (DeepReadonly) types on the App* view-model layer in
//      extended.ts so accidental source mutations become compile errors — then this whole file
//      and the clone can be retired.
//   3. ONLY AFTER 1–2: review Apollo running in dev mode in prod (__DEV__/NODE_ENV in the build).
//      Doing this first would turn the freeze crash into silent localStorage cache corruption.
import {
  LineCustomPropertyKeyType,
  QuoteCustomPropertyKeyType
} from 'graphql/models/extended';
import {
  CustomProperty
} from 'graphql/models/generated';

import { getCustomProperty } from './get-custom-property';

export function setCustomPropertyValue(
  customProperties: CustomProperty[] | undefined | null,
  key: LineCustomPropertyKeyType | QuoteCustomPropertyKeyType,
  value: string | number
): void {
  const property = getCustomProperty(customProperties, key);
  if (property) {
    property.stringValue = String(value);
  }
}

/**
 * Frozen-safe variant of {@link setCustomPropertyValue}. The custom-property objects may be
 * Apollo cache-read results (deep-frozen in dev mode — which this app's prod build also runs in),
 * so they cannot be written in place. The owning `target` is writable, so we replace its
 * `customProperties` array with one carrying an updated copy of the matched property.
 * No-op if the property is not present.
 */
export function setCustomPropertyValueImmutable<T extends { customProperties?: CustomProperty[] | null }>(
  target: T,
  key: LineCustomPropertyKeyType | QuoteCustomPropertyKeyType,
  value: string | number
): void {
  const property = getCustomProperty(target.customProperties, key);
  if (property && target.customProperties) {
    target.customProperties = target.customProperties.map((prop) =>
      prop === property ? { ...prop, stringValue: String(value) } : prop
    );
  }
}
